import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const LinksContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 2px;
`;

export const HeaderLink = styled(Link).attrs((props: { $active: boolean }) => props)`
  color: blue;
  position: relative;
  color: ${(props) => (props.$active ? '#054ad9' : props.theme.colors['neutral-80'])};
  padding: 4.5px 11px;
  cursor: pointer;
  display: block;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  border-width: 1px;
  border-radius: 4px;
  border-color: transparent;

  &:hover {
    border-color: ${({ theme }) => theme.colors['neutral-40']};
  }

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors['neutral-60']};
  }

  ${(props) =>
    props.$active &&
    `&:not(:hover):after {
        content: '';
        width: 4px;
        height: 4px;
        background: #054ad9;
        position: absolute;
        bottom: -1px;
        left: 0;
        border-radius: 50%;
        right: 0;
        margin: auto;
      }
    `};
`;
